import { get } from 'lodash';
import { createSelector } from 'reselect';
import { userSelector } from './baseSelectors';

export const permissionsSelector = createSelector(userSelector, userAuthenticationState =>
    get(userAuthenticationState, 'permissions', {})
);
